'use client';

import { useEffect } from 'react';

export default function NotFoundLogger() {
  useEffect(() => {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') return;
    const apiBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL?.trim() ?? 'https://baseballdataviewer.com';
    const log404Url = apiBaseUrl ? new URL('/api/log-404', apiBaseUrl).toString() : '/api/log-404';

    void fetch(log404Url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        path: window.location.pathname,
        fullUrl: window.location.href,
        query: window.location.search,
        referrer: document.referrer || '',
        userAgent: navigator.userAgent,
        language: navigator.language,
        timestamp: new Date().toISOString(),
      }),
      keepalive: true,
    }).catch(() => {
      // Logging failure should not affect 404 UI.
    });
  }, []);

  return null;
}
